/**
 * mi-comunidad
 * Version 2.0 de la comunidad
 *
 * The version of the OpenAPI document: 2.54.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { NewPublication } from './newPublication';
import { PublicationCompanyExcludingIdPublicationId } from './publicationCompanyExcludingIdPublicationId';
import { PublicationDetailExcludingIdPublicationId } from './publicationDetailExcludingIdPublicationId';
import { PublicationUserExcludingIdPublicationId } from './publicationUserExcludingIdPublicationId';
import { PublicationCityExcludingIdPublicationId } from './publicationCityExcludingIdPublicationId';
import { PublicationBusinessUnitExcludingIdPublicationId } from './publicationBusinessUnitExcludingIdPublicationId';


export interface PublicationControllerCreateRequest { 
    publication?: NewPublication;
    publicationDetail?: Array<PublicationDetailExcludingIdPublicationId>;
    publicationUser?: Array<PublicationUserExcludingIdPublicationId>;
    publicationCompany?: Array<PublicationCompanyExcludingIdPublicationId>;
    publicationBusinessUnit?: Array<PublicationBusinessUnitExcludingIdPublicationId>;
    publicationCity?: Array<PublicationCityExcludingIdPublicationId>;
}

